/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import React, { useState } from 'react';

import './ManagerBar.scss';

import ManagerInfo from './ManagerInfo';
import ManagerDetail from './ManagerDetail';

const ManagerBar = () => {

  const [showDetail, setShowDetail] = useState(false);

  function onClick(e) {
    e.preventDefault();
    if(!showDetail || (showDetail && e.target.id === 'close')) {
      setShowDetail(!showDetail);
    }
  }

  function onCloseClick(e) {
    e.preventDefault();
    setShowDetail(false);
  }
  
  return (
    <div id="manager-bar">
      {!showDetail &&
        <ManagerInfo onClick={onClick}/>
      }
      {showDetail &&
        <ManagerDetail onCloseClick={onCloseClick}/>
      }
    </div>
  );
};

export default ManagerBar;
